module.exports = __webpack_public_path__ + "static/media/Desktop_SearchAppMap.695f4fb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/haf/Desktop_SearchAppMap.png
// module id = 84
// module chunks = 0